import type { ButtonHTMLAttributes, ReactNode } from "react";

// « success » : l'action qui fait avancer un dossier d'un cran (vert plein), à réserver
// à cette famille.
type Variant = "primary" | "ghost" | "ghost-danger" | "danger" | "success";
type Size = "md" | "sm" | "lg";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  icon?: ReactNode;
}

export function Button({
  variant = "primary",
  size = "md",
  icon,
  children,
  className,
  ...rest
}: ButtonProps) {
  const classes = ["btn", `btn--${variant}`, size !== "md" && `btn--${size}`, className]
    .filter(Boolean)
    .join(" ");
  return (
    <button className={classes} {...rest}>
      {icon ? <span className="btn__icon">{icon}</span> : null}
      {children}
    </button>
  );
}
